// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { CatchupMediaStreams } from '../types/catchup/sources'

import type { Options } from '../utils/getStreamEncryptHeader'

import { getStreamHeader } from '../utils/getStreamEncryptHeader'

export const getCatchupProgramSources = (
  domain: string,
  channelId: string,
  programId: string,
  options: Options,
): Promise<ResponseAPI<CatchupMediaStreams>> => {
  const headers = getStreamHeader(options)

  return makeGetRequest(`${domain}/client/api/catchup/channel/${channelId}/program/${programId}/sources`, {
    headers,
  })
}

export default getCatchupProgramSources
